import React, { useState, useContext } from 'react';
import { Paper, Typography, Button } from '@mui/material';
import DropDownSingle from '../../../../../Components/DropDownSingle';
import { COUNTRY_CODE_MAP } from '../../../../../core/constants';
import { Modalv2Context } from '../../../../../Contexts/Modalv2Context';
import useCommonStyles from '../../../../../commonStyles';
import { PLATFORMS } from '../../../../../core/constants';

const ModalAddNewCountry = ({ activeCountryList, daisyChainingConfig }) => {
	const commonClasses = useCommonStyles();
	const { updateModalContent } = useContext(Modalv2Context);
	const [modalActiveCountry, setModalActiveCountry] = useState('');
	// Create a list of country codes for the dropdown
	const countryCodes = [PLATFORMS.DEFAULT, ...Object.keys(COUNTRY_CODE_MAP)];

	const remainingUnactiveCountryList = countryCodes.reduce((acc, countryCode) => {
		if (!activeCountryList.includes(countryCode)) {
			acc.push(`${COUNTRY_CODE_MAP?.[countryCode] || countryCode} (${countryCode})`);
		}
		return acc;
	}, []);

	return (
		<Paper className={commonClasses.modalContentStyle} style={{ height: '30vh' }}>
			<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
				<Typography fontWeight={400} variant="h5" style={{ margin: '.5rem' }}>
					Add New Country
				</Typography>
				<DropDownSingle
					label="Country List"
					isObjectEditor={false}
					directValue={modalActiveCountry}
					updateDirectValue={(newValue) => setModalActiveCountry(newValue)}
					list={remainingUnactiveCountryList}
				/>
				<Button
					variant="contained"
					style={{
						margin: '2rem auto 2rem auto'
					}}
					onClick={() => {
						if (modalActiveCountry) {
							const match = modalActiveCountry.match(/\((\w+)\)$/);
							const activeCountryCode = match ? match[1] : null;
							daisyChainingConfig[activeCountryCode] = {
								enabled: false,
								defaultVastLimit: 1,
								dcVastLimit: 1,
								initialRequestsLimit: 0,
								startWithDcVasts: false,
								vastTags: []
							};
						}
						updateModalContent(null);
					}}
				>
					Add
				</Button>
			</div>
		</Paper>
	);
};

export default ModalAddNewCountry;
